import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "shared/lib/classNames/classNames";
import { Header } from "widgets/Header";
import { Footer } from "widgets/Footer";
import { MainPage } from "pages/MainPage";
const App = () => {
    return (_jsxs("div", { className: classNames("app", {}, []), children: [_jsx(Header, {}), _jsx("main", { children: _jsx(MainPage, {}) }), _jsx(Footer, {})] }));
};
export default App;
